/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_New_LotInputs */

const vi_confirm_return_new_lot = /** @type {(inputs: Confirm_Return_New_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo lô mới cho hàng tốt`)
};

/**

* @param {Confirm_Return_New_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_new_lot = /** @type {((inputs?: Confirm_Return_New_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_New_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_new_lot(inputs)
});